import { AssetAppeal } from "types";
import { getAvatarBgColor, getInitials } from "utils/helper";

const ProsecutorCard: React.FC<{
  selectedProsecutor: string;
  prosecutors: any[];
  referral?: any;
  appeal?: AssetAppeal;
}> = ({ selectedProsecutor, prosecutors, referral, appeal }) => {
  const prosecutor = appeal
    ? appeal?.assigned_prosecutor_name
    : referral?.assigned_prosecutor;
  const getProsecutorName = () => {
    if (selectedProsecutor) {
      const selected = prosecutors.find(
        (pros) => pros?.user?.id === selectedProsecutor
      );
      return selected
        ? `${selected.user?.first_name} ${selected.user?.last_name}`
        : prosecutor;
    }
    return prosecutor;
  };
  const initials = getInitials(prosecutor);
  const bgColor = getAvatarBgColor(prosecutor);

  return (
    <div className="flex items-center gap-3 p-3 border rounded-lg mt-4">
      <div className="flex items-center gap-3 p-3 border rounded-lg mt-4">
        <div
          className={`w-10 h-10 rounded-full flex items-center justify-center text-white text-lg font-semibold flex-shrink-0 mr-3 ${bgColor}`}
        >
          {initials}
        </div>
      </div>
      <div>
        <p className="font-medium text-gray-800">{getProsecutorName()}</p>
        <p className="text-sm text-gray-500">Prosecutor</p>
      </div>
    </div>
  );
};

export default ProsecutorCard;
